import React from "react"
import Image from "next/image"

import { containerVariants, secondaryImage } from "./PostContent.css"
import type { ReducedImage } from "types/cms"
import { extractJSONFromHTML } from "utils/extractJSONFromHTML"
import { InstagramEmbed } from "packages/acquisition/shared/components/Contentful/InstagramEmbed"
import { TikTokVideo } from "components/Contentful/RichTextRenderer/TikTokVideo"
import type {
  ReducedBlogInstaPost,
  ReducedSpotifyPlaylistType,
  ReducedTikTokVideo,
} from "types/blog-v2-types"
import { SpotifyPlaylist } from "../../Shared/SpotifyPlaylist"
import {
  isBlogInstaPost,
  isReducedImage,
  isSpotifyPlaylist,
  isTikTokVideo,
} from "types/typeGuards"

type Props = {
  content: string
  wideTemplate?: boolean
}

export const PostContent: React.FC<Props> = ({ content, wideTemplate }) => {
  const contentArray = extractJSONFromHTML(content)
  return (
    <div
      className={
        wideTemplate ? containerVariants.Wide : containerVariants.Normal
      }
    >
      <div className="content">
        {contentArray.map((element, idx) => {
          let obj:
            | ReducedImage
            | ReducedBlogInstaPost
            | ReducedSpotifyPlaylistType
            | ReducedTikTokVideo
            | string
            | null = null
          try {
            obj = JSON.parse(element)
          } catch (e) {
            // Not a valid JSON, continue to render as HTML
          }

          if (isReducedImage(obj)) {
            const { src, description, filename, caption } = obj
            return (
              <div className={secondaryImage} key={idx}>
                <Image
                  src={src}
                  title={filename}
                  alt={description ?? filename}
                  width={1600}
                  height={900}
                />
                {caption && <span>{caption}</span>}
              </div>
            )
          }

          if (isBlogInstaPost(obj)) {
            return <InstagramEmbed key={idx} id={obj.postLink} />
          }
          if (isTikTokVideo(obj)) {
            return (
              <TikTokVideo
                key={idx}
                videoLink={obj.videoLink}
                videoId={obj.videoId}
              />
            )
          }
          if (isSpotifyPlaylist(obj)) {
            const { href, reference, compact, caption } = obj
            return (
              <SpotifyPlaylist
                key={idx}
                href={href}
                reference={reference}
                compact={compact}
                caption={caption}
              />
            )
          }

          return <div key={idx} dangerouslySetInnerHTML={{ __html: element }} />
        })}
      </div>
    </div>
  )
}
